import React from 'react'
import { EntityData } from 'lib/prismic'
import { PrismicPageScene } from 'modules/prismic'

export const PrismicPageResolver = (props: EntityData<any, string>) => {
  return <PrismicPageScene {...(props as any)} />
}
